"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enums = _interopRequireDefault(require("../enums.js"));
var _feedbackExpressions = _interopRequireDefault(require("../feedback-expressions.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const componentNames = ['feedback'];
const expressions = Object.values(_feedbackExpressions.default);
const highContrast = expressions.map(exp => `HighContrast${exp}`);
const config = {
  expressions: [...expressions, ...highContrast],
  styleProperties: [_enums.default.properties.FEEDBACK_COLOR, _enums.default.properties.ON_FEEDBACK_COLOR]
};
var _default = componentNames.reduce((obj, name) => Object.assign(obj, {
  [name]: config
}), {});
exports.default = _default;